import { DatePipe } from '@angular/common';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UrlBuilderService } from 'src/app/utils/tovpil-url-builder.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import CryptoJS from 'crypto-js';

@Component({
  selector: 'app-tovpil-materials-video-detail-youtube',
  templateUrl: './tovpil-materials-video-detail-youtube.component.html',
  styleUrls: ['./tovpil-materials-video-detail-youtube.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class TovpilMaterialsVideoDetailYoutubeComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferencesParams: CookieTovpil = {};
  globalUserDataFormParams: FormGroup;

  /** WITHOUT SELECTOR PREFERENCES*/
  currentUser: any;
  token: string;
  type: string;
  hash: string;
  id: string;
  name: string;
  path: string;

  youtubeUrl: SafeResourceUrl;
  downloadCdnVideo360: string = null;
  downloadCdnVideo720: string = null;

  /** COMPONENT */
  languages: any[];
  periods: any[];
  currencies: any[];
  stores: any[];


  /** DATAPARENT */
  dataParent: any = {};

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT OVERLAY */
  blocked: boolean = true;
  blockedButton: boolean = false;
  blockedButton360fps: boolean = false;
  blockedButton720fps: boolean = false;

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointGetValidPeriods = "getValidPeriods";
  endPointGetStoreById = "getStoreById";
  endPointGetGuideById = "getGuideById";

  player: any;
  isMuted: boolean = false;
  key = CryptoJS.enc.Utf8.parse('1234567890123456');

  /**
  * This constructor function initializes various services and variables used in the component, and also
  * checks for authentication based on the token and device parameters passed in the URL.
  * @param {MessageService} messageService - This parameter is of type MessageService and is used for
  * displaying messages to the user. It is likely used to show success or error messages during certain
  * operations.
  * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
  * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
  * confirmation before performing certain actions.
  * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
  * making API requests and handling responses.
  * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
  * which is used to access the current route's information. It provides access to the route's
  * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
  * used to subscribe to the
  * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
  * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
  * the current user's information.
  * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
  * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
  * downloading files.
  * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
  * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
  * on data in the application.
  * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
  * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
  */
  constructor(private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private renderer: Renderer2,
    private urlBuilderService: UrlBuilderService,
    private sanitizer: DomSanitizer,
    private translationService: TovpilLanguageService) {

    this.createDataForm();
    this.initConfigs();
    // GET STATE VALUES 
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;

    // GET ROUTE VALUES
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
          this.type = params.type;
          this.id = params.id;
          this.name = params.name;
          this.path = params.path;
        });

    this.currentUser = this.authenticationService.currentUserValue;

    if (this.type === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    }
  }

  /**
   * The ngAfterViewInit function is used to load the YouTube API.
   */
  ngAfterViewInit() {
    this.loadYouTubeAPI();
  }

  /**
   * The function `loadYouTubeAPI` dynamically loads the YouTube iframe API script and initializes a
   * YouTube player with specified options and event handlers.
   */
  loadYouTubeAPI() {
    const tag = this.renderer.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    this.renderer.appendChild(document.body, tag);

    (window as any).onYouTubeIframeAPIReady = () => {
      this.player = new (window as any).YT.Player('player', {
        videoId: this.decrypt(this.id).split('/').pop(),
        playerVars: {
          controls: 0,
          rel: 0,
          showinfo: 0
        },
        events: {
          onReady: () => console.log('YouTube Player ready!')
        }
      });
    };
  }

  /**
   * The function `onPlayerStateChange` logs a message to the console when the video has finished
   * playing.
   * @param {any} event - The `event` parameter in the `onPlayerStateChange` function is an object that
   * contains information about the player state change event. It likely includes properties such as
   * `data`, which represents the new state of the player. In this specific code snippet, the function
   * checks if the `data` property
   */
  onPlayerStateChange(event: any) {
    if (event.data === 0) {
      console.log("Video terminado.");
    }
  }

  /**
   * The play function checks if a player exists and then plays the video.
   */
  play() {
    if (this.player) {
      this.player.playVideo();
    }
  }

  /**
   * The `pause()` function checks if a video player exists and pauses the video if it does.
   */
  pause() {
    if (this.player) {
      this.player.pauseVideo();
    }
  }

  /**
   * The `forward` function in TypeScript seeks the video player forward by a specified number of seconds
   * if the player exists.
   * @param {number} seconds - The `seconds` parameter in the `forward` function represents the number of
   * seconds by which you want to move forward in the media player. This function is used to seek the
   * media player forward by the specified number of seconds.
   */
  forward(seconds: number) {
    if (this.player) {
      const currentTime = this.player.getCurrentTime();
      this.player.seekTo(currentTime + seconds, true);
    }
  }

  /**
   * The `backward` function seeks the video player back by a specified number of seconds if the player
   * exists.
   * @param {number} seconds - The `seconds` parameter in the `backward` function represents the amount
   * of time by which you want to move the current playback position backwards in seconds. This function
   * is designed to work with a media player instance (`this.player`) where you can adjust the playback
   * position by seeking to a new time calculated based
   */
  backward(seconds: number) {
    if (this.player) {
      const currentTime = this.player.getCurrentTime();
      this.player.seekTo(currentTime - seconds, true);
    }
  }

  /**
   * The function `setVolume` sets the volume of a player based on the value from an event.
   * @param {any} event - The `event` parameter in the `setVolume` function is typically an event object
   * that is passed when the volume is changed, such as a change event from a volume control input
   * element. It contains information about the event that occurred, including the target element that
   * triggered the event (in this case,
   */
  setVolume(event: any) {
    const volume = event.target.value;
    if (this.player) {
      this.player.setVolume(volume);
    }
  }

  /**
   * The function `toggleMute` toggles the mute status of a player object in TypeScript.
   */
  toggleMute() {
    if (this.player) {
      this.isMuted = !this.isMuted;
      if (this.isMuted) {
        this.player.mute();
      } else {
        this.player.unMute();
      }
    }
  }

  /**
   * The function `toggleFullScreen` toggles the fullscreen mode of an iframe element in a TypeScript
   * environment.
   */
  toggleFullScreen() {
    const iframe = document.querySelector('iframe');
    if (iframe) {
      if (!document.fullscreenElement) {
        iframe.requestFullscreen().catch(err => {
          console.error(`Error al entrar en fullscreen: ${err}`);
        });
      } else {
        document.exitFullscreen();
      }
    }
  }

  /**
  * The function initializes form groups for configuration and data, and updates the configuration form
  * with query parameters from the route.
  */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferencesParams = await this.userPreferencesService.getSantovTovpilCookie() || null;
    console.debug("VIDEOPLAYER - USER PREFERENCES: " + JSON.stringify(this.globalUserPreferencesParams, null, 2));
  }

  /**
    * The function `createDataForm` in TypeScript initializes a form group with various form controls and
    * default values, as well as setting some controls as disabled.
    */
  createDataForm() {
    this.globalUserDataFormParams = this.fb.group({
      selectedLanguage: new FormControl({ value: null, disabled: false }),
      selectedPeriod: new FormControl({ value: null, disabled: false }),
      selectedStore: new FormControl({ value: null, disabled: false }),
      selectedGuide: new FormControl({ value: null, disabled: false }),
      selectedCoordination: new FormControl({ value: null, disabled: false }),
    });

    this.getConfigs();
  }

  /**
   * The function `getConfigs()` logs the values of `configForm` and `dataForm` in a formatted JSON
   * string.
   */
  getConfigs() {
    console.debug("VIDEOPLAYER - REACTIVE FORM: " + JSON.stringify(this.globalUserDataFormParams.value, null, 2));
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    // DOWNLOAD VIDEO FROM CDN VIMEO
    if (this.dataParent) {
      this.downloadCdnVideo360 = this.dataParent.downloadCdnVideo360 ?? null;
      this.downloadCdnVideo720 = this.dataParent.downloadCdnVideo720 ?? null;
    }

    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        error => {
          this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferencesParams || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = (this.currentUser != null && this.currentUser.tokenProfile ? this.currentUser.tokenProfile : this.token) || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferencesParams.preferences = data;

      this.globalUserDataFormParams.patchValue({
        selectedGuide: this.globalUserPreferencesParams.preferences?.guideId + " " + this.globalUserPreferencesParams.preferences?.fullName,
      });
    } else {
      this.globalUserDataFormParams.patchValue({
        selectedGuide: this.globalUserPreferencesParams.preferences?.guideId + " " + this.globalUserPreferencesParams.preferences?.fullName,
      });

    }

    this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferencesParams?.preferences?.language || null;
    const region = this.globalUserPreferencesParams?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();

      await this.getLanguages();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
    }
  }

  /**
   * The function asynchronously fetches store data and updates the global user data
   * form with the retrieved information.
   * @returns The function returns a boolean value (`true` or `false`) based on the
   * success of fetching store data and updating the `selectedCoordination` value in the
   * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
   * error during the process, it returns `false`.
   */
  async getCoordination(storeId: string) {
    try {

      if (!storeId) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, {
        storeId
      });

      if (result.success) {

        this.globalUserDataFormParams.patchValue({
          selectedStore: result.data,
          selectedCoordination: result.data?.storeId + ' ' + result.data?.descri,
        });
        return true;
      } else {
        console.error("An error occurred while fetching coordination");
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    console.debug("VIDEOPLAYER - LANGUAGES");

    const language = this.globalUserPreferencesParams?.preferences?.language || null;
    const storeId = this.globalUserPreferencesParams?.preferences?.storeId || null;

    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.languages = result.data;

        if (language && storeId) {
          let selectedLanguage = this.languages.find(o => o.valueId === language);

          // NO EXISTE PARA ESA COORDINACION EL SELECCIONADO
          if (selectedLanguage == null && this.languages.length > 0) {
            selectedLanguage = this.languages[0];
          }

          this.globalUserDataFormParams.patchValue({
            selectedLanguage: selectedLanguage
          });

          await this.getInitData();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: this.translations.lbl_resource_not_found , detail: this.translations.lbl_language });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      // this.messageService.add({ severity: 'warn', summary: this.translations.lbl_resource_not_found , detail: this.translations.lbl_language });
    }
  }


  /**
   * The  function fetches valid periods from a service and assigns them to a list, then
   * selects a default period and returns a boolean indicating success.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getValidPeriods(language: string) {
    try {

      const data = await this.tovpilCrudService.fetch(this.endPointGetValidPeriods, language);

      if (!data.success) {
        return false;
      }
      const lstPeriod = data.data || []; // Handle empty data array

      const selPeriod = this.globalUserPreferencesParams?.preferences?.periodSelected ?? null;

      const selectedPeriod = selPeriod?.year
        ? lstPeriod.find(period => period.year === selPeriod.year && period.period === selPeriod.period)
        : lstPeriod[0]; // Default to first period if no selection or year missing

      this.periods = lstPeriod;

      this.globalUserDataFormParams.patchValue({
        selectedPeriod: selectedPeriod
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      return false;
    }
  }

  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {
    try {
      const language = this.globalUserPreferencesParams?.preferences?.language || null;
      const coordinationStoreId = this.globalUserPreferencesParams?.preferences?.storeId || null;


      const validPeriodsResponse = await this.getValidPeriods(language);
      const validCoordinationResponse = await this.getCoordination(coordinationStoreId);

      if (validPeriodsResponse && validCoordinationResponse) {
        this.getConfigs();
        await this.loadData();
      } else {
        console.error("An error occurred while fetching price list:", validPeriodsResponse);
      }
    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
    }
  }

  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData() {
    if (this.globalUserDataFormParams.valid == false) {
      return;
    }

    try {
      this.blocked = false;
    } catch (error) {
      console.error(error);
      this.blocked = false;
    } finally {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    }
  }

  /**
   * The `downloadVideo` function downloads a video file from a specified folder using chunked file
   * transfer and handles success and error cases accordingly.
   */
  downloadVideo(): void {

    const parts = this.path.split('/');
    const folderId = parts[0]; // 'VIDEOITEMS'
    const nameFile = parts[1]; // 'AlwaysFaithful-compress.mp4'

    this.blockedButton = true;

    this.apiService.getFileChunk(folderId, nameFile).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Response:
          const blob = new Blob([event.body], { type: 'application/octet-stream' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = nameFile;
          link.click();
          break;
      }
    }, (error) => {
      console.error('Error downloading file', error);
      this.blockedButton = false;
    }, () => {
      this.blockedButton = false;
    });
  }

  /**
   * The handleError function logs an error message to the console and adds an error message to the
   * message service.
   * @param {string} message - The `message` parameter is a string that represents the error message that
   * occurred while parsing.
   */
  async handleError(message: string) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  /**
   * The goBack function closes the current window.
   */
  async goBack() {
    try {

      let queryParams = {
      };

      let stringRedirect = '/materials/videoPlayerLst';

      const url = this.urlBuilderService.buildUrl(stringRedirect, queryParams);

      // Navegas a la ruta deseada con los parámetros de consulta
      this.router.navigateByUrl(url);
    } catch (error) {
      console.error("An error occurred while navigating:", error);
      //this.handleError('Redirigir a CX4', 'Algo salió mal al redirigir a CX4');
    }
  }

  /** MANAGE PREFERENCES */

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    //console.debug("CX3 RCM - ON CHANGE USER PREFERENCES: ")
    await this.refreshPreferences();

    // RECARGA
    this.initConfigs();
    this.getLanguages();
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = (this.globalUserDataFormParams.get('selectedLanguage').value)?.valueId || null;
    let period = (this.globalUserDataFormParams.get('selectedPeriod').value) || null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      period?.year || null, //_selYear
      period?.period || null, //_selPeriod
      null, //_device
      null, //_storeSelected
      period, //_periodSelected
      null //_stores
    );
  }

  decrypt(encryptedText: string): string {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, this.key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
